import React from "react";
import { RendererProps, getRendererProps } from "../BaseRenderer";
import { getSettingBoolean } from "../../../models/utilities/settingUtilities";
import { ChoiceModel } from "../../../models/ChoiceModel";
import OpenEndRenderer from "./OpenEndRenderer";
import { hasOpenEnd } from "../../../models/utilities/choiceUtilities";

interface Props extends RendererProps {
    choice?: ChoiceModel;
    value?: string;
    name?: string;
    label?: string;
    isSelected?: boolean;
    onOpenEndChange?(choice: ChoiceModel, text: string): void;
    onOpenEndBlur?(choice: ChoiceModel): void;
    size?: string;
    lines?: number;
}

export default function ChoiceOpenEndRenderer(props: Props) {
    const {
        choice,
        name,
        value,
        label,
        isSelected,
        onOpenEndBlur,
        onOpenEndChange,
        size,
        lines,
    } = props;

    if (!hasOpenEnd(choice)) return null;
    if (getSettingBoolean(choice, "DisplayOpenEndOnlyWhenSelected") && !isSelected) return null;

    return (
        <OpenEndRenderer
            {...getRendererProps(props)}
            value={value}
            name={name}
            label={label}
            isDisabled={!isSelected}
            onOpenEndChange={(event) => onOpenEndChange(choice, (event.target as any).value)}
            onOpenEndBlur={() => onOpenEndBlur(props.choice)}
            validationResult={choice.settings.validationResult}
            size={size}
            lines={lines}
        />
    );
}
